


















import { routeHelper } from '../../utils/routeHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { Session } from 'src_client/utils/Session';

@Component({ components: { CommonDialog } })
export default class MaintenunceSelectDialog extends Vue {
  setting() {
    routeHelper(this, 'StudentSettingMain');
  }
  paymentChange() {
    routeHelper(this, 'StudentPaymentReset');
  }
  passwordChange() {
    routeHelper(this, 'StudentPasswordChangePage');
  }

  paymentYuuchoChange() {
    routeHelper(this, 'StudentYuuchoSettingPage');
  }

  get isDev() {
    return location.hostname.includes('localhost');
  }

  public async show() {
    (this.$refs['MaintenunceSelectDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['MaintenunceSelectDialog'] as CommonDialog).hide();
  }
}
